import { createSelector } from 'reselect';

const getReplaceable = (state, replaceableId) => {
  const replaceables = state.asset.templateDefinition.textReplaceables
    ? (state.asset.templateDefinition.textReplaceables || []).concat(
        state.asset.templateDefinition.mediaReplaceables
      )
    : state.asset.templateDefinition.mediaReplaceables;
  if (replaceables) {
    const replaceable = replaceables.find(x => x.id === replaceableId);
    if (replaceable) {
      replaceable.selected = replaceable.id === state.asset.selectedReplaceableId;
      return replaceable;
    }
  }
  return null;
};

const getAutofillData = state => state.asset.autofillData;

const getAutofillColumnData = state => state.asset.autofillColumnData;

export const makeGetReplaceable = () =>
  createSelector([getReplaceable], replaceable => replaceable || {});

export const makeGetAutofillData = () =>
  createSelector(
    [getAutofillData, getAutofillColumnData, getReplaceable],
    (autofillData, autofillColumnData, replaceable) => {
      if (replaceable && replaceable.name) {
        if (autofillColumnData[replaceable.name]) {
          return autofillColumnData[replaceable.name].map(a => a.columns[0].value);
        } else if (autofillData[replaceable.name]) {
          return autofillData[replaceable.name].map(a => a[replaceable.name].value);
        }
      }
      return [];
    }
  );



// WEBPACK FOOTER //
// ./app/selectors/asset.js